import { AppInsights } from "applicationinsights-js";
import { isAdBlockEnabled, isServer } from "../../utils";
import { FingerprintService } from "./Analytics/FingerprintJS/FingerprintService";


class AppInsightService {
  private customDimensionsAppinsights = {};

  public async init() {
    if (isServer) {
      return;
    }

    AppInsights.downloadAndSetup({
      instrumentationKey: "2406d709-0dc7-48ce-9d0b-4b33019499a5",
      disableExceptionTracking: true,
      disableAjaxTracking: true,
      enableDebug: false,
      maxBatchInterval: 0,
      enableSessionStorageBuffer: false,
    });
  }

  public trackPageView(data) {
    AppInsights.trackPageView(null, null, data);
  }

  public trackAppError(error, info = {}) {
    const data: any = {};
    this.addMandatoryDimensions(data).then(() => {
      AppInsights.trackEvent("js-error", {
        error,
        info: JSON.stringify(info),
        adBlockEnabled: isAdBlockEnabled() as any,
        ...{ ...this.customDimensionsAppinsights, ...data },
      });
    });
  }

  public trackEvent(event: string, data: any) {
    this.addMandatoryDimensions(data).then((r) => {
      AppInsights.trackEvent(event, {
        ...this.customDimensionsAppinsights,
        ...data,
      });
    });
  }

  public setCustomDimensions(customDimensions) {
    this.customDimensionsAppinsights = {
      ...this.customDimensionsAppinsights,
      ...customDimensions,
    };
  }

  public async addMandatoryDimensions(props) {
    const fingerprintGlobalCDs =
      FingerprintService.detected || (await FingerprintService.detect());

    this.setCustomDimensions({
      ...fingerprintGlobalCDs,
    });

    return props;
  }
}

export const AppInsightsAnalytics = new AppInsightService();
